import { trpc } from 'root/src/client/v2/trpc/trpc';
import { useRecordId } from 'root/src/client/v2/common/hooks/useRecordId';
import { useBattlePassMnemonicId, } from 'root/src/client/v2/battlePass/features/BattlePassDetails/contexts/battlePassDetails.context';
import { uniqBy } from 'remeda';
import { DarePlatform } from 'root/src/shared/@types/platforms';
import { DEFAULT_PLATFORMS } from 'root/src/client/v2/battlePass/constants';
export const useBattlePassDetails = () => {
    var _a, _b, _c, _d;
    const recordId = useRecordId();
    const mnemonicId = useBattlePassMnemonicId();
    const battlePassDetailsQuery = trpc.battlePass.getBattlePassDetails.useQuery({
        mnemonicId: mnemonicId !== null && mnemonicId !== void 0 ? mnemonicId : recordId,
    });
    const battlePass = (_a = battlePassDetailsQuery === null || battlePassDetailsQuery === void 0 ? void 0 : battlePassDetailsQuery.data) === null || _a === void 0 ? void 0 : _a.battlePass;
    const drops = ((_b = battlePassDetailsQuery === null || battlePassDetailsQuery === void 0 ? void 0 : battlePassDetailsQuery.data) === null || _b === void 0 ? void 0 : _b.drops) || [];
    return {
        battlePass,
        drops,
        creatorTier: ((_c = battlePassDetailsQuery === null || battlePassDetailsQuery === void 0 ? void 0 : battlePassDetailsQuery.data) === null || _c === void 0 ? void 0 : _c.creatorTier) || null,
        newBattlePasses: ((_d = battlePassDetailsQuery === null || battlePassDetailsQuery === void 0 ? void 0 : battlePassDetailsQuery.data) === null || _d === void 0 ? void 0 : _d.newBattlePasses) || [],
        isLoading: battlePassDetailsQuery.isLoading,
        isError: battlePassDetailsQuery.isError,
        refetch: battlePassDetailsQuery.refetch,
    };
};
export const useBattlePassActiveCreatorTier = () => {
    const { creatorTier } = useBattlePassDetails();
    if (!creatorTier) {
        return { creatorTier: 1 };
    }
    return { creatorTier };
};
export const useBattlePassTiers = () => {
    const { drops } = useBattlePassDetails();
    const battlePasses = drops.flatMap((drop) => {
        return drop.dares
            .filter((dare) => Boolean(dare.battlePass))
            .map(dare => dare.battlePass)
            .sort((a, b) => a.tier - b.tier);
    });
    const tiers = uniqBy(battlePasses
        .map(battlePass => battlePass.tier)
        .sort((a, b) => a - b), tier => tier);
    return {
        tiers: tiers.map(tier => ({ label: `Tier ${tier}`, tier })),
    };
};
export const useBattlePassAvailableDaresFilter = () => {
    const { drops } = useBattlePassDetails();
    const dares = drops.flatMap(drop => drop.dares);
    const availableTypes = uniqBy(dares.map(dare => dare.type), type => type);
    const availableLevels = uniqBy(dares.map(dare => dare.level), level => level);
    const availablePlatforms = getAggregatedPlatforms(dares);
    return { availableTypes, availableLevels, availablePlatforms };
};
const getAggregatedPlatforms = (dares) => {
    const platforms = uniqBy(dares.map(dare => dare.platform), platform => platform);
    if (platforms.some(platform => platform === DarePlatform.Any)) {
        return DEFAULT_PLATFORMS;
    }
    return platforms;
};
